import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';
import { Container, Row, Col, Form, InputGroup, Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPaperPlane, faCircleCheck, faArrowRight, faXmark } from '@fortawesome/free-solid-svg-icons';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { theme } from '../../config/theme';
import { toast } from 'react-toastify';
import { LoginManager } from '../../core/login-manager';
import { ResourceManager } from '../../core/resource-manager';
import { LanguageProvider } from '../../core/language-provider';
import { useCandidatePrivacy } from '../../components/CandidatePrivacyModal';

export default function JobApplyReview() {
    const { blue, lightBlue } = theme;
    const { open: openCandidatePrivacy } = useCandidatePrivacy();
    const navigate = useNavigate();
    const location = useLocation();
    const { k } = useParams();
    const id = parseInt(k);

    const [job, setJob] = useState(null);
    const [acceptPrivacy, setAcceptPrivacy] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const form = useMemo(() => (Array.isArray(location.state?.form) ? location.state.form : []), [location.state]);

    const getAnswer = (questionId) => {
        if (!Array.isArray(form)) return undefined;
        return form.find(a => a && a.idQuestion === questionId);
    };

    const getFileName = (questionId) => {
        const v = getAnswer(questionId)?.value;
        if (!v) return '';
        if (typeof v === 'object') {
            if ('name' in v && v.name) return v.name;
            if ('originalFileName' in v && v.originalFileName) return v.originalFileName;
        }
        return '';
    };

    const userInfo = LoginManager.getUserInfo()

    useEffect(() => {
        console.warn(form)
        loadJob();
    }, [id]);

    async function loadJob() {
        const res = await DataManager.getItem('job_post', id);
        if (res && res.success === 1) {
            const item = Array.isArray(res.body) ? res.body[0] : res.body;
            setJob(item);
        }
    }

    const title = job?.title || job?.name || `${LanguageProvider.get('pages.jobApply.position')} #${id}`;

    const hasAnswers = useMemo(() => Array.isArray(form) && form.length > 0, [form]);

    const fileToDataUrl = (file) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });

    async function handleSubmit() {
        if (!acceptPrivacy || submitting) return;
        if (!hasAnswers) {
            toast.error(LanguageProvider.get('pages.jobApplyReview.emptyError') || 'Aggiungi almeno una risposta', { theme: 'colored' });
            return;
        }
        setSubmitting(true);
        try {
            const guard = await ApiManager.sendAuthenticatedRequest('/custom/check_job_request_duplicate', { idJobPost: id });
            if (guard?.error_code === 'job_request.duplicate') {
                toast.warning(LanguageProvider.get('pages.jobApplyReview.duplicateError') || 'Hai già inviato una candidatura per questa posizione.', { theme: 'colored' });
                setSubmitting(false);
                navigate('/profile');
                return;
            }

            // Prepara le risposte, caricando i file al volo
            const answers = await Promise.all((form || []).map(async (a) => {
                if (a.type === '10_FILE') {
                    const v = a.value;
                    if (!v) {
                        return {
                            idJobPostQuestion: { id: a.idQuestion },
                            answerString: null,
                            answerText: null,
                            answerFile: null
                        };
                    }
                    // Se è già metadato uploadato (hash presente), riutilizzalo
                    if (typeof v === 'object' && 'hash' in v) {
                        return {
                            idJobPostQuestion: { id: a.idQuestion },
                            answerString: null,
                            answerText: null,
                            answerFile: v
                        };
                    }
                    // Altrimenti effettua l'upload ora (atteso File PDF)
                    if (v instanceof File) {
                        if (v.type !== 'application/pdf') {
                            throw new Error('Il file deve essere un PDF');
                        }
                        const dataUrl = await fileToDataUrl(v);
                        const res = await ResourceManager.uploadBase64(dataUrl, v.name, 'job_request');
                        if (!(res && res.success === 1)) {
                            throw new Error('Upload fallito');
                        }
                        return {
                            idJobPostQuestion: { id: a.idQuestion },
                            answerString: null,
                            answerText: null,
                            answerFile: res.body // contiene hash/extension
                        };
                    }
                }
                // Altri tipi
                return {
                    idJobPostQuestion: { id: a.idQuestion },
                    answerString: (a.type === '0_STRING' || a.type === '30_DATA' ? a.value : null),
                    answerText: (a.type === '20_TEXT' ? a.value : null),
                    answerFile: null
                };
            }));

            var body = {
                idUser: { id: userInfo.id },
                idJobPost: { id: id },
                source: { value: '0_WEBSITE' },
                answer: answers
            };

            console.log('Submitting application review body:', body);
            var ins = await DataManager.insertItem('job_request', body);
            if (ins.success === 1) {
                const idJobRequest = ins?.id;
                if (idJobRequest) {
                    try {
                        var body = { idJobRequest: idJobRequest }
                        await ApiManager.sendAuthenticatedRequest('/custom/notify_applicant_submission', body);
                    } catch (notifyErr) {
                        console.error('notify_applicant_submission error', notifyErr);
                    }
                } else {
                    console.warn('notify_applicant_submission missing idJobRequest', ins);
                }
                setShowModal(true);
            } else if (ins?.error_code === 'job_request.duplicate') {
                toast.warning(LanguageProvider.get('pages.jobApplyReview.duplicateError') || 'Hai già inviato una candidatura per questa posizione.', { theme: 'colored' });
                navigate('/profile');
                return;
            } else {
                throw new Error('Invio non riuscito');
            }
        } catch (err) {
            console.error(err);
            toast.error(err?.message || 'Errore durante l\'invio della candidatura', { theme: 'colored' });
        } finally {
            setSubmitting(false);
        }
    }

    const [showModal, setShowModal] = useState(false);
    function openModal() {
        setShowModal(true)
    }
    function closeModal() {
        setShowModal(false)
        navigate('/profile')
    }

    return (
        <>
            <Container fluid>
                <Container fluid={'md'}>
                    {/* Title */}
                    <Row className='pt-5 pb-3 align-items-center mb-4'>
                        <Col>
                            <div className='text-muted mt-2'>{LanguageProvider.get('pages.jobApply.applyingFor')}</div>
                            <h2 className='mt-1' style={{ color: blue }}>{title}</h2>
                        </Col>
                    </Row>

                    {/* Stepper */}
                    <Row className='mb-4'>
                        <Col>
                            {(() => {
                                const steps = [
                                    LanguageProvider.get('pages.jobApply.steps.loginRegister'),
                                    LanguageProvider.get('pages.jobApply.steps.additionalData'),
                                    LanguageProvider.get('pages.jobApply.steps.reviewAndSend')
                                ];
                                const current = 3;
                                return (
                                    <>
                                        {/* Mobile compact */}
                                        <div className='d-md-none' style={{ color: blue, fontWeight: 600 }}>
                                            {current}/{steps.length} {steps[current - 1]}
                                        </div>
                                        {/* Desktop stepper */}
                                        <div className='d-none d-md-flex align-items-center gap-3 flex-wrap' style={{ color: blue }}>
                                            {steps.map((label, i) => {
                                                const idx = i + 1;
                                                const isActive = idx === current;
                                                const circleStyle = {
                                                    backgroundColor: isActive ? lightBlue : 'transparent',
                                                    color: isActive ? 'white' : blue,
                                                    border: isActive ? `1px solid ${lightBlue}` : `1px solid ${'#e6edf5'}`,
                                                    width: 28,
                                                    height: 28,
                                                    borderRadius: 4,
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: 600
                                                };
                                                return (
                                                    <div key={label} className='d-flex align-items-center gap-2'>
                                                        <div style={circleStyle}>{idx}</div>
                                                        <div className='me-2'>{label}</div>
                                                        {idx < steps.length && <span className='text-muted'>{'>'}</span>}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </>
                                );
                            })()}
                        </Col>
                    </Row>

                    <hr className='my-4' />

                    <Container>
                        {job?.questions?.map((item, i) => (
                            <Row key={item.id ?? i} className="align-items-center g-3 mb-3">
                                <Col md={3} xs={12} className="text-md-start text-muted">
                                    {item.title}
                                </Col>
                                <Col md={9} xs={12}>
                                    {item?.type?.value === "0_STRING" ? (
                                        <Form.Control
                                            value={getAnswer(item.id)?.value ?? ""}
                                            disabled
                                        />
                                    ) : null}

                                    {item?.type?.value === "10_FILE" ? (
                                        <div className="d-flex flex-column flex-md-row gap-2">

                                            <Form.Control value={getFileName(item.id)} readOnly />

                                        </div>
                                    ) : null}

                                    {item?.type?.value === "20_TEXT" ? (
                                        <Form.Control
                                            as="textarea"
                                            disabled
                                            rows={3}
                                            value={getAnswer(item.id)?.value ?? ""}
                                        />
                                    ) : null}

                                    {item?.type?.value === "30_DATA" ? (
                                        <Form.Control
                                            type="date"
                                            value={getAnswer(item.id)?.value ?? ""}
                                        />
                                    ) : null}
                                </Col>
                            </Row>
                        ))}
                    </Container>

                    <hr className='my-4' />

                    {/* Privacy */}
                    <Row className='mb-4'>
                        <Col md={{ span: 9, offset: 3 }} xs={12}>
                            <Form.Check
                                type='checkbox'
                                id='privacy-consent'
                                label={
                                    <span>
                                        <strong style={{ color: blue }}>
                                            {LanguageProvider.get('pages.jobApplyReview.privacyTitle')}
                                        </strong>
                                        <br />
                                        <span
                                            onClick={(e) => {
                                                const anchor = e.target.closest && e.target.closest('a');
                                                if (anchor && anchor.getAttribute('href') === '/privacy-candidati') {
                                                    openCandidatePrivacy(e);
                                                }
                                            }}
                                            dangerouslySetInnerHTML={{ __html: LanguageProvider.get('pages.jobApplyReview.privacyBodyHtml') }}
                                        />
                                    </span>
                                }
                                checked={acceptPrivacy}
                                onChange={(e) => setAcceptPrivacy(e.target.checked)}
                            />
                        </Col>
                    </Row>

                    {/* Actions */}
                    <Row className='pb-5 g-3'>
                        <Col md={{ span: 3, offset: 3 }} xs={12}>
                            <Button variant='outline-secondary' className='w-100' onClick={() => navigate(`/job/${id}/apply`, { state: { form } })}>
                                ← {LanguageProvider.get('pages.jobDetail.back')}
                            </Button>
                        </Col>
                        <Col md={6} xs={12}>
                            <Button className='w-100' style={{ backgroundColor: lightBlue, borderColor: lightBlue }} disabled={!acceptPrivacy || submitting || !hasAnswers} onClick={handleSubmit}>
                                {submitting ? LanguageProvider.get('pages.jobApplyReview.sending') : LanguageProvider.get('pages.jobApplyReview.submit')} <FontAwesomeIcon icon={faPaperPlane} className='ms-2' />
                            </Button>
                        </Col>
                    </Row>
                </Container>
            </Container>

            <Modal show={showModal} onHide={closeModal} centered>
                <Modal.Body className="text-center p-4 p-md-5">
                    <div className="d-flex justify-content-center mb-3">
                        <FontAwesomeIcon icon={faCircleCheck} style={{ color: '#2CC36B', fontSize: 56 }} />
                    </div>
                    <h2 className="fw-bold mb-2" style={{ color: blue, lineHeight: 1.2 }}>
                        {LanguageProvider.get('pages.jobApplyReview.modal.title')}
                    </h2>
                    <div className="mb-4" style={{ color: blue }}>
                        {LanguageProvider.get('pages.jobApplyReview.modal.body')}
                    </div>
                    <Button className="w-100" style={{ backgroundColor: lightBlue, borderColor: lightBlue }} onClick={closeModal}>
                        {LanguageProvider.get('pages.jobApplyReview.modal.close')} <FontAwesomeIcon icon={faXmark} className='ms-2' />
                    </Button>
                </Modal.Body>
            </Modal>
        </>
    );
}
